export const CHANGE_REDIRECT_URL = 'app/components/NavBar/CHANGE_REDIRECT_URL';



// WEBPACK FOOTER //
// ./src/redux/global/redirect/constants.js